import StateList from './StateList';

export default StateList;